// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const trevenant: PokeData = {
  "id": 709,
  "name": "trevenant",
  "height": 15,
  "weight": 710,
  "base_experience": 166,
  "types": [
    PokeType.GHOST,
    PokeType.GRASS
  ],
  "api_moves": [
    "tackle",
    "leech-seed",
    "growth",
    "confuse-ray",
    "curse",
    "feint-attack",
    "destiny-bond",
    "will-o-wisp",
    "ingrain",
    "astonish",
    "shadow-claw",
    "wood-hammer",
    "hex",
    "horn-leech",
    "phantom-force",
    "forests-curse",
    "branch-poke"
  ],
  "moves": [
    "tackle",
    "confuse-ray",
    "curse",
    "wood-hammer",
    "phantom-force",
    "branch-poke",
    "spectral-snatch",
    "overgrowth",
    "shadow-sneak",
    "shadow-claws",
    "spectral-chain",
    "aromatherapy",
    "night-shade"
  ],
  "evolution_chain": {
    "id": 364,
    "item": null,
    "species": [
      {
        "name": "phantump",
        "order": 708,
        "types": [
          PokeType.GHOST,
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "trevenant",
        "order": 709,
        "types": [
          PokeType.GHOST,
          PokeType.GRASS
        ],
        "evolves_from_species_id": 708,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 132,
    "speed": 90,
    "ability_power": 177
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
